import { LOGOUT_PATH } from 'constant/path';
import { SignoutResponse, User, UserManager, WebStorageStateStore } from 'oidc-client';

export default class AuthService {
  userManager: UserManager;

  constructor() {
    const settings = {
      authority: process.env.REACT_APP_API_AUTHORITY,
      client_id: process.env.REACT_APP_API_CLIENT_ID,
      AllowOfflineAccess: true,
      AllowAccessTokensViaBrowser: true,
      redirect_uri: `${process.env.REACT_APP_API_HOST_Client}/assets/signin-callback.html`,
      silent_redirect_uri: `${process.env.REACT_APP_API_HOST_Client}${LOGOUT_PATH}`,
      post_logout_redirect_uri: `${process.env.REACT_APP_API_HOST_Client}${LOGOUT_PATH}`,
      response_type: 'id_token token',
      scope: process.env.REACT_APP_API_CLIENT_SCOPE,
      userStore: new WebStorageStateStore({ store: window.localStorage }), // Storage user authenticated in localStorage
    };
    this.userManager = new UserManager(settings);
  }

  public getUser(): Promise<User | null> {
    return this.userManager.getUser();
  }

  public logIn(): Promise<void> {
    this.userManager.signinRedirect();
    return Promise.resolve();
  }

  public signinRedirectCallback() {
    return this.userManager.signinRedirectCallback();
  }

  public renewToken(): Promise<User> {
    return this.userManager.signinSilent();
  }

  public logOut(): Promise<void> {
    return this.userManager.signoutRedirect();
  }

  public signOutRedirectCallback(): Promise<SignoutResponse> {
    this.userManager.clearStaleState();
    this.userManager.removeUser();
    return this.userManager.signoutRedirectCallback();
  }
}
